// Tartı Yönetimi (Cihaz Yönetimi > Tartılar) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'devices.scales';

export const devicesScalesGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Tartılar nasıl tanımlanır?'),
  intro: t(`${G}.intro`, 'Ağa bağlı tartılarınızı buraya tanımlarsınız. Kasa kullanacağı tartıyı Hızlı Satış ayarlarından bu listeden seçer; Tartı Senkronu da ürünleri bu tartılara gönderir. IP, port veya barkod ön eki yanlışsa tartılı satış çalışmaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Tartılar'),
    toolbar: t(`${G}.regions.toolbar`, 'Yenile / Yeni Tartı'),
    table: t(`${G}.regions.table`, 'Tartı listesi'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Tartı ekleyin'),
      text: t(`${G}.s1.text`, '"Yeni Tartı" ile pencereyi açın. "Tartı adı" zorunludur (ör. Manav Tartısı); aynı isimde ikinci bir tartı kaydedilemez.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. IP adresi ve port'),
      text: t(`${G}.s2.text`, '"IP adresi" zorunludur; tartının kendi ağ ayarlarında yazan adresi girin (ör. 192.168.1.243). Port, CAS tartılarda 20304\'tür; boş bırakılırsa 20304 kullanılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tartının IP adresi değişirse (ör. modem yeniden başlatıldıktan sonra) burada da güncelleyin; aksi halde kasa tartıya bağlanamaz.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Model ve barkod ön eki'),
      text: t(`${G}.s3.text`, '"Model" tartının markasıdır; şu an CAS CL Serisi (CL3000, CL5000) desteklenir. "Barkod ön eki" tartının bastığı ağırlık etiketinin ilk iki hanesidir; varsayılan 27\'dir. Tartının ayarındaki ön ek ile aynı olmalıdır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kasada "Ağırlık barkodu oku" açıksa, aktif tartılardaki iki haneli ön ekle başlayan etiketler ağırlık etiketi olarak okunur. Ön ek yanlışsa etiket okunmaz.'),
        t(`${G}.s3.tip2`, 'Hiç aktif tartı tanımlı değilse kasa 27 ön ekini kullanır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. Bağlantıyı test edin'),
      text: t(`${G}.s4.text`, '"Bağlantıyı Test Et" kaydetmeden önce tartıya ulaşılıp ulaşılmadığını dener; yanlış IP\'yi kaydetmeden fark edersiniz. Başarılıysa "Tartıya bağlanıldı" ile kapasite, birim, hassasiyet ve anlık ağırlık görünür.'),
      tips: [
        t(`${G}.s4.tip1`, 'Test, bu ekranı açtığınız bilgisayardaki yerel servis (local-service) üzerinden yapılır; bilgisayar tartıyla aynı ağda olmalıdır.'),
        t(`${G}.s4.tip2`, 'Listedeki satırda bulunan test düğmesi tartıyı düzenleme penceresinde açıp testi hemen başlatır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Şube, durum ve kaydetme'),
      text: t(`${G}.s5.text`, '"Şube" isteğe bağlıdır. "Aktif" kapalıysa tartı kasa ayarlarındaki tartı listesinde ve Tartı Senkronu\'nda çıkmaz, kasa onu kullanmaz. "Kaydet" ile kaydedin.'),
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Listeyi okuyun, düzenleyin, silin'),
      text: t(`${G}.s6.text`, 'Listede Ad, Adres (IP:port), Model, Şube, Barkod Ön Eki ve Durum görünür. Kalem düğmesi düzenler, çöp kutusu siler.'),
      tips: [
        t(`${G}.s6.tip1`, 'Silinen tartıyı kullanan kasaların tartı seçimi de temizlenir; o kasalarda yeniden tartı seçmeniz gerekir.'),
      ],
    },
  ],
});
